export default __webpack_public_path__ + "static/media/gray-tick.4673ed3e.svg";